import { STORE_LABS, STORE_CONDUCTED_TESTS, UPDATE_TOTAL_COUNT, UPDATE_LAB_PAYS, APPROVE_LAB, DELETE_LAB } from "./../actions/types";

const INITIAL_STATE = {
	conductedTests: [],
	labs: [],
	totalCocCount: 0
};

export default function(state = INITIAL_STATE, action) {
	switch (action.type) {
		case STORE_CONDUCTED_TESTS:
			return {
				...state,
				conductedTests: action.payload
			};
		case STORE_LABS:
			return {
				...state,
				labs: action.payload
			};
        case UPDATE_TOTAL_COUNT:
            return {
                ...state,
                totalCocCount: action.payload
            };
        case UPDATE_LAB_PAYS:
            return {
                ...state,
                labs: state.labs.map(lab =>
                    lab.id === action.payload.labId
                        ? { ...lab, labPaysForCOCs: action.payload.labPaysForCOCs }
                        : lab
                ),
            };
        case APPROVE_LAB:
            return {
                ...state,
                labs: state.labs.map(lab =>
                    lab.id === action.payload.labId
                        ? { ...lab, status: true, isUnderReview: false }
                        : lab
                ),
            };
        case DELETE_LAB:
            return {
                ...state,
                labs: state.labs.filter(lab => lab.id !== action.payload.labId),
            };

		default:
			return {
				...state
			};
	}
}
